import { ResizeListener } from "@ingka/webc-tools";
import { CarouselFeature } from "./feature-base.js";
const Events = {
  UPDATE: "SKAPA_CAROUSEL_RESIZE_EVENT"
};
class CarouselResizeEvent extends Event {
  constructor(finished) {
    super(Events.UPDATE);
    this.finished = finished;
  }
}
class ResizeHandlerFeature extends CarouselFeature {
  constructor() {
    super(...arguments);
    this.onScrollResizeCallback = ({
      scrollLeft,
      scrollWidth
    }) => {
      if (!this.isResizing && scrollWidth !== 0)
        this.originalScrollPosition = scrollLeft / scrollWidth;
    };
    this.isResizing = false;
    this.originalScrollPosition = 0;
    this.handleResize = (finished) => {
      this.dispatchEvent(new CarouselResizeEvent(finished));
      if (!finished && !this.isResizing) {
        const keepPosition = () => {
          this.host.scrollContainer.scrollLeft = this.originalScrollPosition * this.host.scrollContainer.scrollWidth;
          if (this.isResizing) requestAnimationFrame(keepPosition);
        };
        requestAnimationFrame(keepPosition);
      } else if (finished) {
        this.host.features.scroller.updateScrollState();
      }
      this.isResizing = !finished;
    };
  }
  connectedCallback() {
    this.host.features.scroller.addEventListener(
      "SKAPA_CAROUSEL_SCROLL_UPDATE",
      this.onScrollResizeCallback
    );
    ResizeListener.addResizeListener(this.handleResize);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.host.features.scroller.removeEventListener(
      "SKAPA_CAROUSEL_SCROLL_UPDATE",
      this.onScrollResizeCallback
    );
    ResizeListener.removeResizeListener(this.handleResize);
  }
}
export {
  CarouselResizeEvent,
  Events,
  ResizeHandlerFeature
};
